export const CLIENT_PLATFORM = "web";
